import { Build, Component, Element, Prop } from '@stencil/core';

interface GeoIpResponse {
  country: string;
}

@Component({
  tag: 'uvex-commerce-connector',
  styleUrl: './commerce-connector.scss',
})
export class CommerceConnector {
  @Element() el: HTMLElement;
  @Prop() token: string;
  @Prop() widgetid: string;
  @Prop() locale: string;
  @Prop() displaylanguage: string;
  @Prop() subid: string;
  @Prop() orderNumber: string;
  @Prop() allowedCountries: string;

  async componentWillLoad() {
    if (!Build.isBrowser) {
      return;
    }
    await this.loadCc();
  }

  async componentWillUpdate() {
    this.removeCc();
    await this.loadCc();
  }

  disconnectedCallback() {
    this.removeCc();
  }

  removeCc() {
    const cciWidgets = document.querySelectorAll('#cci-widget, #cci-inline-root');
    if (cciWidgets) {
      cciWidgets.forEach(cciWidget => {
        cciWidget.remove();
      });
    }
  }

  async loadCc() {
    if (localStorage.getItem('uvex-cc') === 'hide') {
      return;
    }

    const geoIp = await this.fetchGeoIp();
    if (geoIp && this.allowedCountries && this.allowedCountries.split(',').indexOf(geoIp.country) === -1) {
      return;
    }

    let trackingId = [];
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (parameter) {
      if (sessionStorage.getItem(parameter)) {
        trackingId.push(parameter + ':' + sessionStorage.getItem(parameter));
      }
    });

    let subid = this.subid;

    const campaignMap = {
      pmaxdeschnittschutz: 'pmaxgloves',
      pmaxdegenericschutzhandschuh: 'pmaxgloves',
    };

    let campaign = (sessionStorage.getItem('utm_campaign') ?? '').toLowerCase();
    if (Object.keys(campaignMap).includes(campaign)) {
      subid = campaignMap[campaign];
    }

    let s = document.createElement('script');
    s.src = 'https://fi-v2.global.commerce-connector.com/cc.js';
    s.id = 'cci-widget';
    s.async = true;
    s.defer = true;
    s.setAttribute('fetchpriority', 'low');
    s.setAttribute('data-token', this.token);
    s.setAttribute('data-widgetid', this.widgetid);
    s.setAttribute('data-locale', this.locale);
    s.setAttribute('data-displaylanguage', this.displaylanguage);
    s.setAttribute('data-subid', subid);
    s.setAttribute('data-man', this.orderNumber);
    s.setAttribute('data-trackingid', trackingId.join(';'));
    this.el.append(s);
  }

  async fetchGeoIp(): Promise<GeoIpResponse> {
    try {
      return (await fetch('/geoip').then(result => result.json())) as GeoIpResponse;
    } catch (e) {}
  }
}
